import React, { Component } from "react";
import { connect } from "react-redux";

import MediaListSlickComponent from "./MediaListSlickComponent";
import styles from "./MediaListSlick.local.scss";

import { fetchMedias } from "Thunks";

export class MediaListByCat2 extends Component {
  state = {
    display: true
  };
  componentDidUpdate(prevProps) {
    const { fetchMedias, categories } = this.props;
    if (
      !categories ||
      categories.length <= 2 ||
      prevProps.categories === categories
    ) {
      return null;
    }

    fetchMedias({
      type: "CAT_2",
      limit: 42,
      filterBy: { category: categories[2] }
    });
  }

  render() {
    const { categories, fetching, medias, community, lng } = this.props;
    const { display } = this.state;

    if (!categories || categories.length <= 2 || !display) {
      return null;
    }
    if (medias.length === 0 && !fetching) {
      return null;
    }
    const nameAttr = `name${lng.charAt(0).toUpperCase() + lng.slice(1)}`;

    return (
      <section className={styles.simpleList}>
        <h2>{categories[2][nameAttr]}</h2>
        <MediaListSlickComponent
          fetching={fetching}
          medias={medias}
          community={community}
        />
      </section>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  fetching: state.medias.cat_2.fetching,
  fetched: state.medias.cat_2.fetched,
  medias: state.medias.cat_2.items,
  categories: state.categories.items,
  community: state.params.navCommunity,
  lng: state.params.lng
});

const mapDispatchToProps = dispatch => ({
  fetchMedias: options => dispatch(fetchMedias(options))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MediaListByCat2);



// WEBPACK FOOTER //
// ./src/components/Community/MediaListSlick/MediaListByCat2.js